/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : App.vue
 * DESCRIPTION    : SPA 루트 페이지
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-10-19      init
 *****************************************************************************/
 
<template>
  <router-view/>
  <LoadingBlock />
</template>
